<template>
  <div class="authentication">
    <van-nav-bar
      fixed
      :title="$route.meta.title"
      left-arrow
      :right-text="$route.meta.right"
      @click-left="goBack"
    >
      <template #right>
        <slot name="right" />
      </template>
    </van-nav-bar>
    <div class="frame-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    // console.log(this.$route)
  },
  methods: {
    async goBack() {
      const path = this.$route.path
      if (window.history.length <= 1) {
          if(window.ReactNativeWebView)window.ReactNativeWebView.postMessage(JSON.stringify({type:4,msg:'返回上一页'}));
          return false
      } else {
          this.$router.go(-1)
      }
      setTimeout(() => {
        if (path === this.$route.path) {
          this.$webview.notice('CLOSE_WEBVIEW')
        }
      }, 100)
    }
  }
}
</script>

<style scoped lang="less">
.authentication {
  // height: 100%;
}
.van-nav-bar__text:active {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/AppFrame/index.vue